import {
  JWTClaimsRole,
  PermissionsEnum,
  permissionsEnumSchema,
  psychologistHeadlineEnumSchema,
} from "@mindlercare/schema";
import CONSTANTS from "core/constants";
import { Slot } from "../../core/types";

const DanmarkStrategy = {
  patientCardTabs: {
    BOOKINGS: CONSTANTS.PATIENT_CARD_TABS.BOOKINGS,
    ICBT: CONSTANTS.PATIENT_CARD_TABS.ICBT,
    PROMOCODES: CONSTANTS.PATIENT_CARD_TABS.PROMOCODES,
    ACTIONS: CONSTANTS.PATIENT_CARD_TABS.ACTIONS,
  },
  patientSearchFields: {
    FIRSTNAME: CONSTANTS.SEARCH_TERMS.FIRSTNAME,
    LASTNAME: CONSTANTS.SEARCH_TERMS.LASTNAME,
    USER_ID: CONSTANTS.SEARCH_TERMS.USER_ID,
    EMAIL: CONSTANTS.SEARCH_TERMS.EMAIL,
  },
  psychologist: {
    userData: {
      rows: [
        CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS.EDITABLE_NAME,
        CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS
          .EDITABLE_PHONE_AND_UNEDITABLE_EMAIL,
      ],
    },
    headlineKeys: [psychologistHeadlineEnumSchema.enum.authorised],
    hasRequiredAdeli: false,
    hasPersonnummer: false,
  },
  specialities: {
    hasFilteredSpecialities: false,
  },
  slots: {
    isPayable: true,
  },
  marketHasStatisticsDashboard: false,
  slotTemplates: [
    CONSTANTS.SLOT_TEMPLATES.NEW_VISIT,
    CONSTANTS.SLOT_TEMPLATES.TECH_TEST,
    CONSTANTS.SLOT_TEMPLATES.BLOCKER,
    CONSTANTS.SLOT_TEMPLATES.REVISIT,
    CONSTANTS.SLOT_TEMPLATES.PARENTAL_SUPPORT,
    CONSTANTS.SLOT_TEMPLATES.APPOINTMENT_50,
  ],
  patientCard: {
    status_label: "STATUS",
  },
  showEditPatientDetails: true,
  showRevisitLabelSuffix: false,
  showInsuranceInfoPsychologist: true,
  showInsuranceInfoAdmin: true,
  showInsurancePlan: true,
  showSavedCardStatus: false,
  showExtraInfoPatientBookings: false,
  showSessionCountColumn: false,
  changeSlotStatus: {
    enabled: true,
    enabledForRoles: ["Psychologist"] as JWTClaimsRole[],
    enabledForPermission: permissionsEnumSchema.enum.EDIT_PATIENT_DETAILS,
    feeStatuses: [] as Slot["status"][],
    getSlotStatuses: (
      roles: JWTClaimsRole[],
      permissions: PermissionsEnum[],
    ) => {
      const isPsychologistWithoutEditPermission =
        roles.includes("Psychologist") &&
        !roles.includes("Admin") &&
        !permissions.includes("EDIT_PATIENT_DETAILS");

      if (isPsychologistWithoutEditPermission) {
        return CONSTANTS.UPDATABLE_BOOKING_STATUS_DK_PSYCHOLOGIST;
      }
      return CONSTANTS.UPDATABLE_BOOKING_STATUS;
    },
  },
  clinicalGuidelinesHref:
    "https://drive.google.com/file/d/1eVGL2PmAhr4rOSXdkaJXj6OlV3NB8M-x/view?usp=drive_link",
};

export default DanmarkStrategy;
